<template>
  <div class="table-page-wrapper">

    <div v-show="searchStatus" class="search-wrapper">
      <el-input v-model="tableParams.searchKey" clearable  placeholder="输入广告位code或名称" />
      <el-select v-model="tableParams.dspId" clearable filterable  placeholder="请选择DSP名称">
        <el-option v-for="item in dspList" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      <search-dsp-label-select v-model="tableParams.tag" :dsp-id="tableParams.dspId" @upTag="upTag" />
      <search-slot-Type-select v-model="tableParams.slotTypeId" />
      <el-select v-model="tableParams.settlementType" clearable placeholder="请选择合作模式" >
        <el-option v-for="item in settlementTypeList" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      <el-select v-model="tableParams.appType" clearable placeholder="请选择设备类型" >
        <el-option v-for="item in appTypeList" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      <el-select v-model="tableParams.isEnable" clearable placeholder="请选择状态" >
        <el-option label="开启" :value="0"></el-option>
        <el-option label="暂停" :value="1"></el-option>
      </el-select>
      <el-select v-model="tableParams.subjectId" clearable placeholder="请选择主体" >
        <el-option v-for="item in subjectList" :label="item.subjectName" :value="item.subjectId"></el-option>
      </el-select>
      <el-button @click="toQuery" type="primary" >搜索</el-button>
    </div>

    <div class="table-wrapper">
      <table-column @search="searchColumn" @refresh="toQuery" @change="changeColumn" :column="columns"
                    style="padding-bottom: 10px;">
        <el-upload :action="$baseURL + 'Dsp/importDspSlot'" :headers="header" :show-file-list="false"
                   :on-progress="onLoading" :on-success="onSuccess">
          <el-button v-loading.fullscreen.lock="loading" type="primary" size="mini">批量新增</el-button>
        </el-upload>
        <el-button @click="
          downExcel('/Dsp/slot/template', 'DSP广告位模板')
        " type="warning" size="mini" style="margin-left: 10px">下载模板</el-button>
        <el-button @click="add" type="primary" size="mini">新增</el-button>
      </table-column>

      <el-table v-loading="tableLoading" :data="tableData" height="80vh" :header-cell-style="{ background: '#fafafa' }"
                highlight-current-row     tooltip-effect="dark" :default-sort="{ prop: 'isEnable', order: 'ascending' }" size="small" class="js-table"
                style="width: 100%">
        <el-table-column v-for="(v, i) in checkColumns" :prop="v.field" :label="v.title" :width="v.width"
                         :sortable="v.field === 'isEnable'" :min-width="v.minWidth" :key="i" align="center">
          <template v-slot="scope">
            <span v-if="v.field === 'dspSlotCode'">{{ scope.row[v.field] || '-' }}</span>
            <span v-else-if="v.field === 'billingType'">{{ billingTypeMap[scope.row[v.field]] || '-' }}</span>
            <span v-else-if="v.field === 'dspFlowType'">{{ dspFlowTypeMap[scope.row[v.field]] || '-' }}</span>
            <span v-else-if="v.field === 'settlementType'">
              {{ settlementTypeMap[scope.row[v.field]] || '-' }}{{ scope.row.settlementType == 0 ? '：' +
              scope.row.cpmPrice : ""
              }}
            </span>
            <span v-else-if="v.field === 'appVer'">
              <template v-if="scope.row[v.field]">
                <el-popover placement="left" width="400px" trigger="click">
                  <template #reference>
                    <span :style="{ color: '#4b4be3', cursor: 'pointer' }">查看</span>
                  </template>
                  <div>{{ scope.row[v.field] }}</div>
                </el-popover>
              </template>
              <div v-else>-</div>
            </span>
            <template v-else-if="v.field === 'dspSlotExt'">
              <el-tooltip popper-class="tooltip-width" effect="dark" :content="scope.row[v.field]" placement="top-start">
              <div class="tab-editor">
                    <span @click="handleCopy">{{ scope.row[v.field] }}</span>
              </div>
              </el-tooltip>
            </template>
            <span v-else-if="v.field === 'slotName'">
              <template v-if="scope.row.slotFlowList && scope.row.slotFlowList.length">
                <el-popover placement="left" width="400px" trigger="click">
                  <template #reference>
                    <span
                      :style="scope.row.isEnable ? { color: 'rgb(181 181 181)', cursor: 'pointer' } : { color: '#4b4be3', cursor: 'pointer' }">查看</span>
                  </template>
                  <el-tag v-for="item in scope.row.slotFlowList" :key="item.slotId"
                          :style="!item.deliveryStatus ? { marginRight: '10px', marginBottom: '5px' } : { color: 'rgb(181 181 181)', marginRight: '10px', marginBottom: '5px' }">
                    {{ `${item.slotName}（${item.flowSize}）` }}
                  </el-tag>
                </el-popover>
              </template>
              <span v-else>-</span>
            </span>
            <template v-else-if="v.field === 'isEnable'">
              <el-switch v-model="scope.row.isEnable" active-color="#13ce66" :active-value="0" :inactive-value="1"
                         @change="upstate(scope.row)" />
            </template>
            <span v-else>{{ scope.row[v.field] }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="250">
          <template v-slot="scope" align="center">
            <el-button @click="update(scope.row.dspSlotId)" type="success" size="mini">编辑</el-button>
            <el-button @click="toPage(scope.row)" type="primary" size="mini">流量配置</el-button>
            <router-link :to="{path:'/heatmap',query:{
                dspSlotId:scope.row['dspSlotId'],
                date:newDate(),
                slotName:scope.row['dspSlotName']
                }
            }" target="_blank" style="margin-left: 10px" >
              <el-button type="primary" size="mini">热力图</el-button>
            </router-link>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination @size-change="sizeChange" @current-change="currentChange" :total="pagination.total"
                     :pager-count="6" :current-page="pagination.pageNum" :page-size="pagination.pageSize" :page-sizes="[10, 30, 60]"
                     background layout="total,sizes,prev,pager,next" style="margin-top: 40px;" />
    </div>

    <m-form @submit="toQuery" ref="form" title="广告位 " />

  </div>
</template>

<script>
import TableColumn from '@/components/TableColumn'
import mForm from './form'
import { upDspStata } from '@/api/manage/dsp/dsp'
import { getDspName } from '@/api/select'
import initTableMixin from '@/mixins/initTable'
import SearchDspLabelSelect from '@/components/SearchDspLabelSelect'
import SearchSlotTypeSelect from '@/components/SearchSlotTypeSelect'
import { mapGetters } from 'vuex'
import { downExcelMixin } from '@/mixins/downExcel'
import { appTypeList, appTypeMap } from '@/const/app-type'
import { billingTypeMap } from '@/const/billing-type'
import { settlementTypeMap, settlementTypeList } from '@/const/settlement-type'
import { formatDate, NORM_DATE_PATTERN, PURE_DATE_PATTERN } from '@/util/format'
import { getMasterSubjectInfo } from "@/api/report/dsp";

export default {
  name: 'Manage/dsp/ad',
  components: {
    TableColumn,
    SearchDspLabelSelect,
    SearchSlotTypeSelect,
    mForm
  },
  mixins: [initTableMixin, downExcelMixin],
  data () {
    return {
      billingTypeMap,
      settlementTypeMap,
      settlementTypeList,
      appTypeMap,
      appTypeList,
      dspFlowTypeMap: { 0: '空', 1: '展示', 2: '请求' },
      dspList: undefined,
      columns: [
        { field: 'dspSlotCode', title: '广告位Code' },
        { field: 'dspSlotName', title: 'DSP广告位名称' },
        { field: 'dspSlotId', title: 'DSP广告位编号' },
        { field: 'dspName', title: '所属DSP' },
        { field: 'billingType', title: '预算类型' },
        { field: 'slotTypeName', title: '广告位类型' },
        { field: 'settlementType', title: '合作模式' },
        { field: 'appName', title: '应用名称' },
        { field: 'appBundle', title: '应用包名' },

        { field: 'tag', title: '标签' },

        { field: 'appVer', title: '应用版本' },
        { field: 'appType', title: '设备类型' },
        { field: 'slotName', title: '已匹配媒体' },
        { field: 'dspFlowSize', title: '预算流量' },
        { field: 'dspFlowType', title: '预算类型' },
        { field: 'maxQps', title: 'QPS' },
        { field: 'dspSlotExt', title: '扩展字段', width: 100},
        { field: 'createTime', title: '创建时间' },
        { field: 'isEnable', title: '状态' }
      ],
      header: {},
      loading: false,
      subjectList:[]
    }
  },
  created () {
    this.getSubjectInfo()
    this.getDspName()
    this.header = {
      Authorization: 'Bearer ' + this.access_token
    }
  },
  computed: {
    ...mapGetters(['access_token'])
  },
  mounted () {
    if (localStorage.getItem('pagination')) {
      this.pagination = JSON.parse(localStorage.getItem('pagination'))
      this.tableParams = JSON.parse(localStorage.getItem('tableParams'))
      this.init()
      localStorage.removeItem('pagination')
      localStorage.removeItem('tableParams')
    } else {
      this.init()
    }
  },
  methods: {
    beforeInit () {
      this.tableUrl = '/Dsp/getDspSlot'
      return true
    },
    getSubjectInfo(){
      getMasterSubjectInfo().then(res=>{
        this.subjectList = res.data
      })
    },
    add () {
      this.$refs.form.show()
    },
    update (row) {
      this.$refs.form.show(row)
    },
    upstate (row) {
      const state = {
        dspSlotId: row.dspSlotId,
        isEnable: row.isEnable
      }
      if (state.dspSlotId) {
        upDspStata(state)
      }
    },
    getDspName () {
      getDspName().then(res => {
        if (res.code === 200) {
          const arr = []
          res.data.forEach(item => {
            const obj = { value: item.dspId, label: item.dspName }
            arr.push(obj)
          })
          this.dspList = arr
        }
      })
    },
    onLoading () {
      this.loading = true
    },
    handleCopy(e) {
      const text = e.target.innerText
      const input = document.createElement('input')

      input.setAttribute('id', 'copyInput')
      input.setAttribute('value', text)
      document.getElementsByTagName('body')[0].appendChild(input)
      document.getElementById('copyInput').select()
      if (document.execCommand('copy')) {
        this.$message({
          type: 'success',
          message: '复制成功'
        })
      } else {
        this.$message({
          type: 'error',
          message: '浏览器不支持复制功能'
        })
      }
      document.getElementById('copyInput').remove()
    },
    onSuccess (res) {
      this.loading = false
      if (res.code === 200) {
        this.$message({
          message: '已成功导入',
          type: 'success'
        })
      }else{
        debugger
        this.$message({
          message: res.msg,
          type: 'error'
        })
      }

    },
    toPage (row) {
      let appType = null
      if (row.appType === 'Android') {
        appType = 1
      } else if (row.appType === 'ios') {
        appType = 2
      } else if (row.appType === '鸿蒙') {
        appType = 3
      } else {
        appType = 4
      }
      localStorage.setItem('pagination', JSON.stringify(this.pagination))
      localStorage.setItem('tableParams', JSON.stringify(this.tableParams))
      localStorage.setItem('appType', JSON.stringify(appType))
      localStorage.setItem('dspSlotId', JSON.stringify(row.dspSlotId))
      this.$router.push({
        path: 'ad/config'
      })
    },
    upTag (tag) {
      this.tableParams.tag = tag
    },
    newDate () {
      return formatDate(new Date(), PURE_DATE_PATTERN)
    }
  }
}
</script>

<style scoped lang="scss">
.search-wrapper {
  padding: 15px 15px 5px;
  margin-bottom: 10px;
  background: #ffffff;

  &>* {
    margin-right: 15px;
    margin-bottom: 10px;

    &:last-child {
      margin-right: 0;
    }
  }

  &>.el-select,
  &>.el-input {
    width: 220px;
  }
}

.table-wrapper {
  padding: 15px;
  background: #ffffff;

  .table__operation {
    padding-bottom: 10px;
  }
}

.tab-editor {
  width: 80px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: center;
}

.el-table::before {
  height: 0;
}

.el-pagination {
  text-align: right;
}
</style>
